import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { plcTermCodesList } from "../../../types/axios";

interface reportSliceReducer {
  plcTermCodesList: plcTermCodesList[];
  plcTermCodeValue: string;
}

const initialState: reportSliceReducer = {
  plcTermCodesList: [],
  plcTermCodeValue: "",
};

const ReportsSliceReducer = createSlice({
  name: "plcreports",
  initialState,
  reducers: {
    setPlcTermCodesList(state, action: PayloadAction<plcTermCodesList[]>) {
      state.plcTermCodesList = action.payload;
    },
    setPlcTermDataValue(state, action: PayloadAction<string>) {
      state.plcTermCodeValue = action.payload;
    },
  },
});

export const { setPlcTermCodesList, setPlcTermDataValue } =
  ReportsSliceReducer.actions;

export default ReportsSliceReducer.reducer;
